var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.checked ? 'slider active-slider' : 'slider',on:{"click":_vm.changeInput}},[_c('div',{class:_vm.disabled ? 'slider-button disabled-button ' : _vm.checked ? 'slider-button active-button' : 'slider-button'})])}
var staticRenderFns = []

export { render, staticRenderFns }